import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      {/* Top Bar */}
      <div className="bg-slate-900 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-sm gap-2">
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 hover:text-green-400 transition-colors">
              <Phone size={16} />
              <span>{companyInfo.phone}</span>
            </a>
            <span className="text-gray-500">|</span>
            <a href={`tel:${companyInfo.office}`} className="flex items-center gap-2 hover:text-green-400 transition-colors">
              <Phone size={16} />
              <span>{companyInfo.office}</span>
            </a>
            <span className="text-gray-500 hidden sm:inline">|</span>
            <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:text-green-400 transition-colors">
              <Mail size={16} />
              <span className="hidden sm:inline">{companyInfo.email}</span>
            </a>
          </div>
          <div className="text-xs text-gray-300">
            {companyInfo.address}
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <header className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}>
        <nav className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Company Name */}
            <div className="cursor-pointer flex items-center gap-3" onClick={() => scrollToSection('home')}>
              <img 
                src={companyInfo.logo} 
                alt={companyInfo.name}
                className="h-12 w-auto"
              />
              <h1 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight">
                ITALSERRANDE SRL
              </h1>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              <button onClick={() => scrollToSection('home')} className="text-slate-700 hover:text-green-600 font-medium transition-colors">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="text-slate-700 hover:text-green-600 font-medium transition-colors">
                Chi Siamo
              </button>
              <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-green-600 font-medium transition-colors">
                Servizi
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-slate-700 hover:text-green-600 font-medium transition-colors">
                Progetti
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-slate-700 hover:text-green-600 font-medium transition-colors">
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('quote')} 
                className="bg-green-600 text-white px-6 py-2.5 rounded-lg hover:bg-green-700 transition-all hover:shadow-lg font-medium"
              >
                Preventivo Gratuito
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-slate-700 hover:text-green-600 transition-colors"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="flex flex-col gap-4">
                <button onClick={() => scrollToSection('home')} className="text-slate-700 hover:text-green-600 font-medium transition-colors text-left">
                  Home
                </button>
                <button onClick={() => scrollToSection('about')} className="text-slate-700 hover:text-green-600 font-medium transition-colors text-left">
                  Chi Siamo
                </button>
                <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-green-600 font-medium transition-colors text-left">
                  Servizi
                </button>
                <button onClick={() => scrollToSection('gallery')} className="text-slate-700 hover:text-green-600 font-medium transition-colors text-left">
                  Progetti
                </button>
                <button onClick={() => scrollToSection('faq')} className="text-slate-700 hover:text-green-600 font-medium transition-colors text-left">
                  FAQ
                </button>
                <button 
                  onClick={() => scrollToSection('quote')} 
                  className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-all font-medium"
                >
                  Preventivo Gratuito
                </button>
              </div>
            </div>
          )}
        </nav>
      </header>
    </>
  );
};

export default Header;
